export const faqs = [
  {
    question: "Posez-vous des volets en rénovation sur une fenêtre existante ?",
    answer: "Oui, absolument. C'est l'une de nos prestations les plus demandées à Strasbourg. La pose en rénovation consiste à remplacer le volet roulant existant — coffre, tablier et mécanisme — sans toucher à la maçonnerie ni à la fenêtre. Le nouveau volet s'adapte au cadre existant. C'est rapide, propre et sans dégâts. Dans la plupart des cas, l'intervention dure entre 2 et 4 heures selon la taille et le nombre de baies.",
  },
  {
    question: "Quel est le délai entre la demande de devis et la pose ?",
    answer: "Après votre première prise de contact, nous venons sur place dans les 48 heures pour la visite et les mesures. Le devis vous est envoyé sous 24h. Une fois validé, la pose est programmée sous 7 à 14 jours selon les disponibilités et la disponibilité des matériaux. Pour les projets urgents, nous faisons de notre mieux pour accélérer les délais. Nous vous tenons informés à chaque étape.",
  },
  {
    question: "Manuel ou électrique : que choisir ?",
    answer: "Le choix dépend de votre budget, de vos besoins et de la configuration de votre logement. Le manuel (sangle ou manivelle) est plus économique, fiable et sans entretien. L'électrique offre un confort quotidien irrénable : un bouton, une télécommande ou une application pour commander tous vos volets. Pour les personnes à mobilité réduite ou les grandes baies, l'électrique est souvent préférable. Nous vous conseillons gratuitement lors de la visite.",
  },
  {
    question: "Le devis est-il vraiment gratuit et sans engagement ?",
    answer: "Oui, totalement. La visite sur place, les mesures et le devis sont gratuits et sans aucun engagement. Vous recevez un document détaillé avec le prix de la pose, le matériel, la main-d'œuvre et les délais. Vous prenez votre temps pour décider. Si vous validez, nous programmons la pose. Si vous ne validez pas, vous ne payez rien.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes sur la pose de volet roulant
        </h2>
        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-brand-light rounded-xl border border-brand-border p-6 md:p-8">
              <h3 className="text-brand-blue text-base font-bold mb-3">{faq.question}</h3>
              <p className="text-brand-text text-sm leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}